export default "__VITE_ASSET__kh1qPT6g__"